import { InputContainer } from "@modules/formik/components/inputContainer"
import { HUText } from "@modules/ui/components/huText"
import { FieldValueChange } from "@src/typings/formik"
import { ChevronDown, ChevronUp } from "lucide-react"
import { useState } from "react"
import { useTheme } from "styled-components"

type InputNumberCursorProps<K> = {
  label?: string
  name: string
  textDescription?: string
  isInvalid: boolean
  isRequiredInput: boolean
  setFieldValue: FieldValueChange<K>
  error?: React.JSX.Element
  min?: number
  max?: number
  initialValue?: number
} & React.HTMLAttributes<HTMLDivElement>

export function InputNumberCursor<K>({
  label,
  name,
  isRequiredInput,
  isInvalid,
  setFieldValue,
  textDescription,
  error,
  min,
  max,
  initialValue,
  ...props
}: InputNumberCursorProps<K>): React.JSX.Element {
  const theme = useTheme()
  const [count, setCount] = useState(initialValue || 0)

  const increment = () => {
    if (max && count >= max) return
    setFieldValue(name, count + 1)
    setCount(count + 1)
  }
  const decrement = () => {
    if (min && count <= min) return
    setFieldValue(name, count - 1)
    setCount(count - 1)
  }

  return (
    <>
      <InputContainer
        isRequiredInput={isRequiredInput}
        label={label}
        name={name}
        isInvalid={isInvalid}
        error={error}
        {...props}
      >
        <div className="flex flex-column w-full">
          {textDescription && (
            <HUText fontStyle="BM" color={theme.neutralColor700}>
              {textDescription}
            </HUText>
          )}
          <div className="flex justify-content-between gap-3 border-1 border-neutralColor-200 rounded-full px-3">
            <span className="flex align-items-center">{count}</span>
            <div className="flex flex-column ">
              <ChevronUp size={20} onClick={increment} className="cursor-pointer" />
              <ChevronDown size={20} onClick={decrement} className="cursor-pointer" />
            </div>
          </div>
        </div>
      </InputContainer>
    </>
  )
}
